import React from 'react';

import DocumentsTitle from './components/DocumentsTitle';
import DocumentsBody from './components/DocumentsBody';

const DocumentsPage = () => {
  return (
    <>
      <DocumentsTitle />
      <DocumentsBody />
    </>
  );
};

export default DocumentsPage;
